import request from '@/request'

export const getView = (data) => {
  return request({
    url: '/mobile_PartyInfo/view.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 1.19 .1 获得问卷
export const getExam = (data) => {
  return request({
    url: '/mobile_extExaminfo/getExam.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 1.19 .2 提交答题结果
export const save = (data) => {
  return request({
    url: '/mobile_extExaminfo/save.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 1.15 .4 判断是否已抽奖
export const isAward = (data) => {
  return request({
    url: '/mobile_LotteryBase/isAward.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const award = (data) => {
  return request({
    url: '/mobile_LotteryBase/award.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const add = (data) => {
  return request({
    url: '/mobile_PartyUser/add.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const relation = (data) => {
  return request({
    url: '/mobile_LotteryBase/relation.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const getRand = (data) => {
  return request({
    url: '/inf_Common/getRand.action',
    method: 'post',
    data,
    isMd5: false
  })
}

export const updateuser = (data) => {
  return request({
    url: '/mobile_LotteryBase/updateuser.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const isAwardbefore = (data) => {
  return request({
    url: '/mobile_LotteryBase/isAwardbefore.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const getUserItem = (data) => {
  return request({
    url: '/mobile_UserAccountCredit/getUserItem.action',
    method: 'post',
    data,
    isMd5: false
  })
}
